module.exports = __webpack_public_path__ + "teqbahn-assets/media/19.e68f890d.jpg";